import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4b5f2524"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "action-bar"
};
const _hoisted_2 = {
  class: "action"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "clear"
}, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  return _openBlock(), _createElementBlock("div", {
    class: "good-list",
    ref: _ctx.bindContainertDom
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    size: "20",
    onClick: _ctx.toBack,
    class: "action-left",
    color: "#ffffff"
  }, null, 8, ["onClick"]), _createVNode(_component_van_icon, {
    name: "ellipsis",
    size: "20",
    class: "action-right",
    color: "#ffffff"
  }), _createVNode(_component_van_icon, {
    name: "like-o",
    size: "20",
    class: "action-right",
    color: "#ffffff"
  }), _createVNode(_component_van_icon, {
    name: "search",
    size: "20",
    class: "action-right",
    color: "#ffffff"
  }), _hoisted_3])]), _hoisted_4, _createElementVNode("div", {
    class: "content",
    ref: _ctx.bindContentDom
  }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, n => {
    return _createElementVNode("p", {
      key: n
    }, "这是内容");
  }), 64))], 512)], 512);
}